<script lang="ts" setup>
import { ROUTE_BLOG_CATEGORY, ROUTE_BLOG_PAGE } from "~/constants/routes";

const { replaceParams } = useRouteParams();
const props = defineProps<{
  title: string;
  id: string;
  sourceUrl: string;
  slug: string;
  categories: Array<{ name: string; slug: string }>;
}>();

function matchHeight(selector: string): void {
  const elements = document.querySelectorAll(selector);
  let maxHeight = 0;

  elements.forEach((el) => {
    if (el instanceof HTMLElement) {
      el.style.height = "";
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    }
  });

  elements.forEach((el) => {
    if (el instanceof HTMLElement) {
      el.style.height = `${maxHeight}px`;
    }
  });
}

const postCategoriesLength = computed(() => props.categories?.length ?? 0);

onMounted(() => {
  matchHeight(".matchHeight");
});
</script>

<template>
  <div
    class="tw-px-[6px] tw-w-full sm:tw-w-1/2 md:tw-w-1/3 tw-mb-[56px] sm:tw-mb-[35px] post-card"
  >
    <NuxtLink
      :style="{ backgroundImage: `url(${sourceUrl})` }"
      class="tw-block tw-max-h-[276px] tw-bg-cover tw-bg-no-repeat tw-bg-center"
      :to="`/blog/${slug}/`"
    >
      <div class="tw-pt-[57%]"></div>
    </NuxtLink>
    <strong
      class="tw-block tw-font-bold tw-font-agendaCond tw-text-[14px] tw-text-nl-green-200 tw-uppercase tw-tracking-[0.07em] tw-mb-2 tw-pt-[11px] sm:matchHeight"
    >Categories:
      <template v-for="(category, index) in categories" :key="category?.name">
        <nuxt-link :to="{path: replaceParams(ROUTE_BLOG_CATEGORY, {slug: category?.slug})}" rel="category tag">
          {{ category?.name }}
        </nuxt-link>
        <span v-if="index !== postCategoriesLength - 1">, </span>
      </template>
    </strong>
    <p
      class="tw-font-black tw-font-bookmania tw-text-[24px] sm:tw-text-[22px] tw-leading-[1.25] sm:tw-leading-[1.36] tw-tracking-[0.04em]"
    >
      <nuxt-link :to="{path: replaceParams(ROUTE_BLOG_PAGE, {slug})}" class="hover:tw-text-nl-green-200">
        {{ props.title }}
      </nuxt-link>
    </p>
  </div>
</template>
